import { render, staticRenderFns } from "./LoadingMessage.vue?vue&type=template&id=5b47be82"
import script from "./LoadingMessage.vue?vue&type=script&lang=js"
export * from "./LoadingMessage.vue?vue&type=script&lang=js"
import style0 from "./LoadingMessage.vue?vue&type=style&index=0&id=5b47be82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports